module.exports = __webpack_public_path__ + "img/barNine.973b8a46.jpg";